import api from "./api";

export const sidebarMenuService = {
  // Menu Items CRUD
  getAllMenuItems: () => api.get("/sidebar-menu/items"),
  getMenuItemById: (id) => api.get(`/sidebar-menu/items/${id}`),
  createMenuItem: (data) => api.post("/sidebar-menu/items", data),
  updateMenuItem: (id, data) => api.put(`/sidebar-menu/items/${id}`, data),
  deleteMenuItem: (id) => api.delete(`/sidebar-menu/items/${id}`),

  // Assignments
  getAllAssignments: () => api.get("/sidebar-menu/assignments"),
  getAssignedMenuItems: (roleId, adminId) => {
    const params = new URLSearchParams();
    if (roleId) params.append("roleId", roleId);
    if (adminId) params.append("adminId", adminId);
    return api.get(`/sidebar-menu/assigned?${params.toString()}`);
  },
  assignMenuItems: (data) => api.post("/sidebar-menu/assign", data),
  deleteAssignment: (id) => api.delete(`/sidebar-menu/assignments/${id}`),
};

